import { Accounting } from 'anchor-scout-common/types';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
const EMPTY_CUSTOMERS = [];
const queryKeyFor = (accounting)=>accounting === Accounting.QBO ? QueryKeys.QboCustomers : QueryKeys.XeroCustomers;
export const useAccountingCustomers = function useAccountingCustomers(accounting) {
    let { refreshOnHookMount = false, enabled = true } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            queryKeyFor(accounting)
        ],
        queryFn: ()=>api.accounting.getCustomers({
                accounting
            }),
        enabled,
        refreshOnHookMount
    });
    return {
        customers: data !== null && data !== void 0 ? data : EMPTY_CUSTOMERS,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
